import * as Styled from "./Styles";
import InputButtonList from "../InputButtonList/InputButtonList";
import { ButtonType } from "../InputButton/InputButton";
import { useState } from "react";
import { scenarios } from "./SurveyData";
import MoreInfoButton from "../MoreInfoButton/MoreInfoButton";

interface Props {
  data?: boolean[];
  onChange?: (data: boolean[]) => void;
}

export default function Scenarios(props: Props) {
  const { data = null, onChange = () => null } = props;
  const [selectedValues, setSelectedValues] = useState(data);
  const handleChanges = (values: any) => {
    setSelectedValues(values);
    onChange(values);
  };
  return (
    <Styled.QuestionWrapper>
      <Styled.UserName>Hi Janice! 👋</Styled.UserName>
      <Styled.Title>
        Let's start with the primary reason you are looking to hire internationally.
      </Styled.Title>
      <Styled.Description>
        Your goals and objectives help us understand the EOR capabilities that best match your
        needs.
        <MoreInfoButton triggerChat={() => null} />
      </Styled.Description>
      <InputButtonList
        type={ButtonType.multiline}
        multiselect={false}
        options={scenarios}
        size={{ width: 185, height: 100 }}
        selected={selectedValues instanceof Array ? selectedValues : null}
        onChange={(values) => handleChanges(values)}
      />
    </Styled.QuestionWrapper>
  );
}
